import dayjs from 'dayjs';
import AppInput from '../AppInput';

export function AppDatePicker({ id, rest, optionObject, register, error }) {
    // console.log(dayjs(new Date()), dayjs(new Date()).format('DD/MM/YYYY'));

    return (
        <AppInput
            error={error}
            id={id}
            label="Date"
            // max={dayjs(new Date()).format('YYYY-MM-DD')}
            optionObject={optionObject}
            register={register}
            type="date"
            {...rest}
        />
    );
}
